import { AccordionWidget } from './accordion-widget'
import { BasicGalleryWidget } from './basic-gallery-widget'
import { ButtonWidget } from './button-widget'
import { BlockQuoteWidget } from './block-quote-widget'
import { HeadingWidget } from './heading-widget'
import { HtmlWidget } from './html-widget'
import { IconListWidget } from './icon-list-widget'
import { ImageWidget } from './image-widget'
import { ImageBoxWidget } from './image-box-widget'
import { TableWidget } from './table-widget'
import { TestimonialWidget } from './testimonial-widget'
import { SlidesWidget } from './slides-widget'
import { TextEditorWidget } from './text-editor-widget'
import { Element } from './element'
import { Section } from './section'
import { Column } from './column'
import { VideoWidget } from './video-widget'

export class WidgetCollection {
  readonly accordion = new Array<AccordionWidget>()
  readonly basicGallery = new Array<BasicGalleryWidget>()
  readonly button = new Array<ButtonWidget>()
  readonly blockQuote = new Array<BlockQuoteWidget>()
  readonly heading = new Array<HeadingWidget>()
  readonly html = new Array<HtmlWidget>()
  readonly iconList = new Array<IconListWidget>()
  readonly imageBox = new Array<ImageBoxWidget>()
  readonly image = new Array<ImageWidget>()
  readonly table = new Array<TableWidget>()
  readonly textEditor = new Array<TextEditorWidget>()
  readonly testimonial = new Array<TestimonialWidget>()
  readonly video = new Array<VideoWidget>()
  readonly slides = new Array<SlidesWidget>()

  constructor (elements: Iterable<Element>) {
    this.collect2(elements)
  }

  private collect2 (elements: Iterable<Element>): void {
    for (const el of elements) {
      if (el instanceof Section) {
        this.collect2(el.cols)
      } else if (el instanceof Column) {
        this.collect2(el.elements)
      } else if (el instanceof AccordionWidget) {
        this.accordion.push(el)
      } else if (el instanceof BasicGalleryWidget) {
        this.basicGallery.push(el)
      } else if (el instanceof ButtonWidget) {
        this.button.push(el)
      } else if (el instanceof BlockQuoteWidget) {
        this.blockQuote.push(el)
      } else if (el instanceof HeadingWidget) {
        this.heading.push(el)
      } else if (el instanceof HtmlWidget) {
        this.html.push(el)
      } else if (el instanceof IconListWidget) {
        this.iconList.push(el)
      } else if (el instanceof ImageBoxWidget) {
        this.imageBox.push(el)
      } else if (el instanceof ImageWidget) {
        this.image.push(el)
      } else if (el instanceof TableWidget) {
        this.table.push(el)
      } else if (el instanceof TextEditorWidget) {
        this.textEditor.push(el)
      } else if (el instanceof TestimonialWidget) {
        this.testimonial.push(el)
      } else if (el instanceof VideoWidget) {
        this.video.push(el)
      } else if (el instanceof SlidesWidget) {
        this.slides.push(el)
      }
    }
  }
}

export function collect (...elements: Element[]): WidgetCollection {
  return new WidgetCollection(elements)
}
